
import { Route, Routes } from "react-router"
// import { checkLoginStatus } from "src/utils/functions"
// import { useDispatch, useSelector } from "react-redux"
import ProtectedRouteAuth from "./ProtectedRouteAuth";
import PageNotFound from "../Layout/NotFound";
import { routesData } from "./routesData";
import { useSelector } from "react-redux";
// import { useSelector } from "react-redux";
// import { getAccessToken, getMenuList } from "src/reduxStorage/selectors"
// import { useEffect } from "react"
// import { setAccessToken } from "src/reduxStorage/systemSlice"

const { unProtectedRoutes, protectedRoutes } = routesData

const UIRoutes = () => {
  // const accessToken = useSelector(getAccessToken)
  const isLoggedIn = useSelector((state) => state.authTracking.isLoggedIn);
  // const dispatch = useDispatch()

  // const loginStatus = accessToken ? checkLoginStatus(accessToken) : "NOT_LOGGED_IN"

  // const isLoggedIn = loginStatus === "LOGGED_IN"

  // TODO: Implement session expiry handling
  // const isSessionExpired = loginStatus === "SESSION_EXPIRED"

  const filterRouteWithAccess = (route) => {
    // const menuData = menuList.find((menu) => menu.key === route.key)
    // return menuData?.access || false
    return true
  }

  // const { token } = useLocation().state || { token: "" }

  // useEffect(() => {
  //   if (token !== "") {
  //     dispatch(setAccessToken(token))
  //   }
  // }, [token, dispatch])

  return (
    <Routes>
      {!isLoggedIn &&
        unProtectedRoutes.map((route, index) => <Route key={index} path={route.path} element={route.component} />)}

      <Route element={<ProtectedRouteAuth isLoggedIn={isLoggedIn} />}>
        {protectedRoutes.filter(filterRouteWithAccess).map((route, index) => (
          <Route key={index} path={route.path} element={route.component}>
            {route.subRoutes &&
              route.subRoutes.map((subRoute, subIndex) => (
                <Route key={subIndex} path={subRoute.path} element={subRoute.component} />
              ))}
          </Route>
        ))}

        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  )
}

export default UIRoutes
